import { z } from 'zod';
import type { ZodType } from 'zod';

import type { I18n } from '@change-corgi/core/i18n';

import type { ContractFormValues } from '../submitContractRequest';

/** Never surface `issue.message` — zod's defaults are hardcoded English. */
export function createContractFormSchema(translate: I18n['translate']): ZodType<ContractFormValues> {
	const requiredMessage = translate('corgi.ambassadors.modal.required_field_error');
	const emailFormatMessage = translate('corgi.ambassadors.modal.email_format_error');

	// The `z.string({ error })` argument covers a non-string input, which for these fields only
	// happens when the value is absent — same user-facing situation as an empty string.
	return z.object({
		name: z.string({ error: requiredMessage }).trim().nonempty({ error: requiredMessage }),
		// Split into two stages so an empty value reports "required" while a non-empty but malformed
		// one reports the format message; `z.email()` alone conflates the two.
		email: z
			.string({ error: requiredMessage })
			.trim()
			.nonempty({ error: requiredMessage })
			.pipe(z.email({ error: emailFormatMessage })),
		handle: z.string({ error: requiredMessage }).trim().nonempty({ error: requiredMessage }),
		petitionIdea: z.string().optional(),
		videoLink: z.string().optional(),
		notSure: z.boolean().default(false),
	}) satisfies ZodType<ContractFormValues>;
}
